module.exports = __webpack_public_path__ + "static/media/MTL_ASC_SUP1.f47eb096.png";